module.exports = __webpack_public_path__ + "static/media/påse-min.517f252d.png";